import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import classNames from "classnames";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Favorite from "@material-ui/icons/Favorite";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import { TiArrowForward } from "react-icons/ti";

import {
  localApi,
  credentials,
  adminId,
  convertToNextTenth,
} from "utils/headApi";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Spinner from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";
import CornerRibbon from "react-corner-ribbon";

import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import logo from "assets/img/examples/apple-insha-bangles-icon.png";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

const useStyles = makeStyles(productStyle);
const useStyle = makeStyles(aboutUsStyle);
const useStylPop = makeStyles(popOver);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function InshaProductList() {
  const [prodList, setProdList] = React.useState([]);
  const [page, setpage] = React.useState(0);
  const [loginModal, setLoginModal] = React.useState(false);

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);

  const classes = useStyles();
  const classe = useStyle();
  const classPop = useStylPop();

  const activeSession = sessionStorage.getItem("sessionData");

  async function getProdSEO() {
    const results = await fetch(localApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const res = await results.json();

    // console.log(res.map((f) => f.state));
    setStateList(res.map((f) => f.state));

    axios
      .get(localApi + `/admin/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        setCompanyList(res.data.AdminList.map((f) => f.company));
      });

    axios
      .get(localApi + `/category/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const items = res.data.map((f) => f.title);

        const uniqueItems = items.filter(
          (item, index, self) =>
            index ===
            self.findIndex((i) => i.toLowerCase() === item.toLowerCase()),
        );

        setCategoryList(uniqueItems);
      });

    axios
      .get(localApi + `/parent/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const itemss = res.data.map((f) => f.title);

        const uniqueItemss = itemss.filter(
          (item, index, self) =>
            index ===
            self.findIndex((i) => i.toLowerCase() === item.toLowerCase()),
        );
        setParentList(uniqueItemss);
      });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  // const fetchData = async () => {
  //   // console.log(page + 1);
  //   setpage(page + 1);
  // axios
  //   .get(
  //       localApi +
  //       `/product/list/byLimitActive?admin_id=${adminId}&active=1&page=${page}&size=4`,
  //       {
  //         headers: {
  //           Authorization: `Basic ${credentials}`,
  //         },
  //         credentials: true,
  //       }
  //     )
  //     .then((res) => setProdList([...prodList, ...res.data]));
  // };

  const fetchData = async () => {
    // console.log(page + 1);
    setpage(page + 1);

    try {
      const response = await fetch(
        `${localApi}/product/list/byLimitActive?admin_id=${adminId}&active=1&page=${page}&size=4`,
        {
          method: "GET",
          // ✅ for sending cookies/session
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const updatedList = [...prodList, ...data];

      setProdList(updatedList);

      // print only parent ids for clarity
      // console.log(updatedList.map(p => p.parent.id));
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchData();
    setTimeout(hideAlertPop, 2000);
    setLoginModal(true);
  }, []);

  const hideAlertPop = () => {
    setLoginModal(false);
  };

  return (
    <div className={classes.productPage}>
      <Helmet>
        <html lang="en" />

        <title>
          Imitation Jewellery & Bangles Collection | INSHA BANGLES India
        </title>

        <meta
          name="description"
          content="Explore a premium range of imitation jewellery and bangles designs from INSHA BANGLES, crafted with precision and modern artistry. Our collection features an exclusive variety of Meenakari bracelets, Punjabi kada, Sikh kada, stylish kada for men, Pola gold-plated designs, gold churi new designs, and gold socket bauti patterns—perfectly suited for both traditional and contemporary fashion, At INSHA BANGLES, we specialize in high-quality imitation jewellery manufactured using advanced plating techniques such as gold plating, two-tone and three-tone plating, micro gold plating, rhodium plating, rose gold plating, and silver plating. Each piece is designed to deliver a premium look with long-lasting shine, durability, and affordability, making it ideal for retailers, wholesalers, and exporters, Upgrade your collection with our latest imitation jewellery designs that combine elegance, craftsmanship, and competitive wholesale pricing—all under one trusted brand, Explore premium imitation jewellery and bangles collection from INSHA BANGLES. Gold plated, micro gold, rhodium, and designer bangles available for wholesale and export across India."
        />

        <meta
          name="keywords"
          content="bangles collection, imitation jewellery India, gold plated bangles, wholesale bangles supplier, designer bangles, rhodium bangles, micro gold bangles, bangles manufacturer India, imitation jewellery manufacturer India, imitation bangles wholesale, designer bangles collection, gold plated bangles wholesale, artificial jewellery manufacturer Mumbai, imitation jewellery supplier India, bangles manufacturer Mumbai, fashion jewellery wholesale India, micro gold plated bangles, rhodium plated bangles, designer kada bangles, Seminario bangles set, daily wear bangles set, traditional Indian bangles, bridal imitation bangles, fancy bangles collection, lightweight bangles design, latest bangles design 2026, premium imitation jewellery manufacturer in Mumbai, wholesale gold plated bangles supplier in India,
latest designer bangles collection for women, affordable imitation jewellery for retailers, micro gold and rhodium bangles manufacturer India, imitation jewellery exporter from India, bulk bangles supplier for shops and resellers, trendy artificial jewellery collection online India, imitation jewellery in Mumbai, bangles manufacturer in Mumbai, wholesale jewellery market in Mumbai, imitation jewellery supplier in India, INSHA BANGLES imitation jewellery, INDIAN BANGLES wholesale collection, INSHA BANGLES manufacturer and exporter, INSHA BANGLES latest design collection, buy imitation bangles online India, best imitation jewellery wholesale price, bulk artificial jewellery supplier, export quality imitation jewellery, low price designer bangles wholesale
"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://inshabangles.com/product-list" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Bangles Collection | INSHA BANGLES"
        />
        <meta
          property="og:description"
          content="Browse stylish bangles and imitation jewellery from INSHA BANGLES."
        />
        <meta
          property="og:url"
          content="https://inshabangles.com/product-list"
        />
        <meta
          property="og:image"
          content="https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Bangles Collection | INSHA BANGLES"
        />
        <meta
          name="twitter:description"
          content="Browse stylish bangles and imitation jewellery."
        />
        <meta
          name="twitter:image"
          content="https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png"
        />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Bangles Collection",
            url: "https://inshabangles.com/product-list",
            description:
              "Explore imitation jewellery and bangles collection from INSHA BANGLES.",
          })}
        </script>
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="dark"
        // color="transparent"
        // changeColorOnScroll={{
        //   height: 100,
        //   color: "dark",
        // }}
      />
      <Parallax
        image={require("assets/img/Product-List.jpg").default}
        // filter="dark"
        className={classes.pageHeader}
        style={
          window.innerWidth <= 600
            ? {
                height: "260px",
                minHeight: "260px",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }
            : {}
        }
      >
        <div className={classe.container}>
          <GridContainer>
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                // classe.textCenter,
              )}
            >
              <h1 className={classe.title}>Product List</h1>
              <h4 style={{ color: "white" }}>
                Insha{"'"}s products are light-weight , elegant and
                sophisticated - the<br />perfect fit for today{"'"}s modern women
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.section, classes.sectionGray)}>
        <div className={classes.container}>
          <Dialog
            style={{ marginTop: "10%" }}
            classes={{
              root: classPop.modalRoot,
              paper: classPop.modal + " " + classPop.modalLogin,
            }}
            open={loginModal}
            TransitionComponent={Transition}
            keepMounted
            // onClose={() => setLoginModal(false)}
            aria-labelledby="login-modal-slide-title"
            aria-describedby="login-modal-slide-description"
          >
            <DialogTitle
              id="login-modal-slide-title"
              disableTypography
              className={classPop.modalHeader}
            >
              <h5>Loading...</h5>
              <DialogContent
                id="login-modal-slide-description"
                className={classPop.modalBody}
              >
                <GridContainer justify="center">
                  <Spinner
                    onChange={() => hideAlertPop()}
                    style={{ color: "black" }}
                  />
                  {/* <Spinner onChange={() => hideAlertPop()} style={{ color: "#00acc1" }} />
                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#f44336" }} />
                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#ff9800" }} />
                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#9c27b0" }} /> */}
                </GridContainer>
                <br />
              </DialogContent>
            </DialogTitle>
          </Dialog>
          <div className={classes.relatedProducts}>
            <h3 className={classNames(classes.title, classes.textCenter)}>
              You may also be interested in:
            </h3>
            <InfiniteScroll
              dataLength={prodList.length}
              next={fetchData}
              hasMore={true}
            >
              <div className={classes.container}>
                <GridContainer>
                  {prodList &&
                    prodList.map((prod) => (
                      <GridItem sm={6} md={3} key={prod.id}>
                        <Card product>
                          <CardHeader image>
                            {/* <CornerRibbon
                          position={prod.total > 0 ? "top-left" : "top-right"} // position="top-right" // OPTIONAL, default as "top-right"
                          fontColor="#f0f0f0" // OPTIONAL, default as "#f0f0f0"
                          backgroundColor="#00acc1" // OPTIONAL, default as "#2c7"
                          containerStyle={{}} // OPTIONAL, style of the ribbon
                          style={{ fontSize: "13px", fontWeight: "bold" }} // OPTIONAL, style of ribbon content
                          className="" // OPTIONAL, css class of ribbon
                        >
                          {" "}
                          {prod.total > 0 ? "In Stock" : "Make To Order"}
                        </CornerRibbon> */}
                            <a
                              href={`/insha-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}
                              // &Plating=${prod.plating.description.slice(8)}
                            >
                              {/* <img src={cardProduct1} alt="cardProduct" /> */}
                              {/* {prod.design1.img1active === 1 ? (
                            <img
                              src={imgApi + "" + prod.design1.image1}
                              alt="..."
                            />
                          ) : prod.design2.img2active === 1 ? (
                            <img
                              src={imgApi + "" + prod.design2.image2}
                              alt="..."
                            />
                          ) : prod.design3.img3active === 1 ? (
                            <img
                              src={imgApi + "" + prod.design3.image3}
                              alt="..."
                            />
                          ) : prod.design4.img4active === 1 ? (
                            <img
                              src={imgApi + "" + prod.design4.image4}
                              alt="..."
                            />
                          ) : prod.design5.img5active === 1 ? (
                            <img
                              src={imgApi + "" + prod.design5.image5}
                              alt="..."
                            />
                          ) : prod.design6.img6active === 1 ? (
                            <img
                              src={imgApi + "" + prod.design6.image6}
                              alt="..."
                            />
                          ) : (
                            ""
                          )} */}
                              <img
                                src={prod.productimage[0].cpanelPath}
                                alt="..."
                              />
                              <p
                                style={{
                                  position: "absolute",
                                  top: "65%",
                                  left: "50%",
                                  width: "65px",
                                  height: "65px",
                                  transform: "translate(-50%, -50%)",
                                }}
                              >
                                <img src={logo} alt="..." />
                                {/* {imgApi + "" + prod.design1.image1 !==
                            imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="..." />
                            ) : imgApi + "" + prod.design2.image2 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="..." />
                            ) : imgApi + "" + prod.design3.image3 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="..." />
                            ) : imgApi + "" + prod.design4.image4 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="..." />
                            ) : imgApi + "" + prod.design5.image5 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="..." />
                            ) : imgApi + "" + prod.design6.image6 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="..." />
                            ) : (
                              ""
                            )} */}
                              </p>
                            </a>
                          </CardHeader>
                          <CardBody>
                            <h6
                              className={classNames(
                                classes.cardCategory,
                                classes.textRose,
                              )}
                            >
                              {prod.category.title + " " + prod.parent.title}{" "}
                              <br /> {prod.itemCodeNumber}-{prod.id}
                            </h6>
                            <h4 className={classes.cardTitle}>
                              {prod.prodDescription}
                            </h4>
                            <div className={classes.cardDescription}>
                              {(prod.readyGram * prod.sets.pcs).toFixed(4)} Avg
                              Gram Of {prod.sets.setDesc} {"and "}
                              {prod.box.boxDesc}
                              {","} {prod.packingMaterial.type}
                              {","} {prod.box.brandName}
                              {","} {prod.ctnDescription}
                              {"."}
                            </div>
                          </CardBody>
                          <CardFooter className={classes.justifyContentBetween}>
                            <div className={classes.price}>
                              {prod.gstCash === true ? (
                                <>
                                  <h5>
                                    <span style={{ color: "red" }}>
                                      Price ₹{" "}
                                      {convertToNextTenth(
                                        prod.taxInclude / prod.box.box,
                                      ) + " Inc."}
                                    </span>
                                  </h5>
                                </>
                              ) : (
                                <>
                                  <h5>
                                    <span style={{ color: "black" }}>
                                      Price ₹{" "}
                                      {convertToNextTenth(
                                        prod.cashPrice / prod.box.box,
                                      )}
                                    </span>
                                  </h5>
                                </>
                              )}
                              {/* {activeSession ? "" : prod.taxCalculation.profitactive === 1 ? <h5>Price <span style={{ color: "red" }}>₹ {(prod.taxCalculation.taxincl / prod.box.box).toFixed(2)}/-</span></h5> : <h5>Price <span>₹ {(prod.taxCalculation.taxincl / prod.box.box).toFixed(2)}/-*</span></h5>}

                                                {!activeSession ? <h6><a href="/bangles-login">Login</a> to see prices and exciting offers.
                                                </h6> : prod.taxCalculation.profitactive === 1 ? <h6>Price <span style={{ textDecoration: "line-through", color: "red" }}>₹{(prod.taxCalculation.taxincl / prod.box.box).toFixed(2)}/</span>{" "} ₹ {(prod.taxCalculation.cash / prod.box.box).toFixed(2)}/-*</h6> :
                                                    <h6>Price <span style={{ textDecoration: "line-through" }}>₹{(prod.taxCalculation.taxincl / prod.box.box).toFixed(2)}/</span> {" "} ₹ {(prod.taxCalculation.cash / prod.box.box).toFixed(2)}/-*</h6>
                                                } */}

                              {/* {!activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              prod.taxCalculation.cash_gst === 1 ? (
                                <>
                                  <h5>
                                    <span style={{ color: "red" }}>
                                      Price ₹{" "}
                                      {(
                                        prod.taxCalculation.taxincl /
                                        prod.box.box
                                      ).toFixed(2)}
                                      /-
                                    </span>
                                  </h5>{" "}
                                  <h6>
                                    <a href="/bangles-login">Login</a> to see
                                    prices and exciting offers.
                                  </h6>{" "}
                                </>
                              ) : (
                                <h5>
                                  Price{" "}
                                  <span>
                                    ₹{" "}
                                    {(
                                      prod.taxCalculation.cash / prod.box.box
                                    ).toFixed(2)}
                                    /-*
                                  </span>
                                </h5>
                              )
                            ) : prod.taxCalculation.cash_gst === 1 ? (
                              <>
                                <h5>
                                  <span style={{ color: "#9c27b0" }}>
                                    Price ₹{" "}
                                    {(
                                      prod.taxCalculation.taxincl / prod.box.box
                                    ).toFixed(2)}
                                    /-
                                  </span>
                                </h5>{" "}
                                <h6>
                                  <a href="/bangles-login">Login</a> to see
                                  prices and exciting offers.
                                </h6>
                              </>
                            ) : (
                              <h5>
                                Price{" "}
                                <span>
                                  ₹{" "}
                                  {(
                                    prod.taxCalculation.cash / prod.box.box
                                  ).toFixed(2)}
                                  /-*
                                </span>
                              </h5>
                            )
                          ) : (
                            ""
                          )}

                          {activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "red",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            ) : (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#9c27b0",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            )
                          ) : (
                            ""
                          )} */}
                            </div>
                            <div className={classes.stats}>
                              <Tooltip
                                id="tooltip-top"
                                title="Save to Wishlist"
                                placement="top"
                                classes={{ tooltip: classes.tooltip }}
                              >
                                <Button justIcon color="rose" simple>
                                  <Favorite />
                                </Button>
                              </Tooltip>
                            </div>
                          </CardFooter>
                          <div
                            style={{ textAlign: "center", marginBottom: "7px" }}
                          >
                            <Button
                              color="rose"
                              href={`/insha-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}
                            >
                              Buy Now
                            </Button>
                          </div>
                        </Card>
                      </GridItem>
                    ))}
                </GridContainer>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
